// extracted by mini-css-extract-plugin
export default {"sideBannerContainer":"style-module--sideBannerContainer--iWOXP","bannerLink":"style-module--bannerLink--F6180","bannerImage":"style-module--bannerImage--iwBb5"};